const FEEDBACK_SESSION_KEY = 'fl:dashboard:cmuFeedback:v1';

export function loadDashboardFeedbackSession() {
    if (typeof window === 'undefined') return null;
    try {
        const raw = sessionStorage.getItem(FEEDBACK_SESSION_KEY);
        if (!raw) return null;
        const d = JSON.parse(raw);
        if (d.v !== 1) return null;
        const now = Date.now();
        const deadlines = { ...(d.deadlines || {}) };
        Object.keys(deadlines).forEach((k) => {
            if (deadlines[k] <= now) delete deadlines[k];
        });
        const pendingSurveyTestIds = (d.pendingSurveyTestIds || [])
            .map(String)
            .filter((id) => deadlines[id] != null);
        return {
            deadlines,
            pendingSurveyTestIds,
            endedTestSnapshots: d.endedTestSnapshots && typeof d.endedTestSnapshots === 'object' ? d.endedTestSnapshots : {},
            pinnedTestIds: (d.pinnedTestIds || []).map(String),
            postSurveyKeep: new Set((d.postSurveyKeep || []).map(String)),
        };
    } catch {
        return null;
    }
}

export function persistDashboardFeedbackSession({
    deadlines,
    pendingSurveyTestIds,
    endedTestSnapshots,
    pinnedTestIds,
    postSurveyKeep,
}) {
    if (typeof window === 'undefined') return;
    try {
        const payload = {
            v: 1,
            deadlines,
            pendingSurveyTestIds,
            endedTestSnapshots,
            pinnedTestIds,
            postSurveyKeep,
        };
        sessionStorage.setItem(FEEDBACK_SESSION_KEY, JSON.stringify(payload));
    } catch {
        /* ignore quota / private mode */
    }
}
